import { createApp, h } from "vue";
import { createInertiaApp, router } from "@inertiajs/vue3";
import AppLayout from "../layouts/AppLayout.vue";

createInertiaApp({
  title: (title) => (title ? `${title} – Emmalagat` : "Emmalagat"),
  resolve: (name) => {
    const pages = import.meta.glob("../pages/**/*.vue", { eager: true });
    const page = pages[`../pages/${name}.vue`];
    if (page.default.layout === undefined) {
      page.default.layout = AppLayout;
    }
    return page;
  },
  setup({ el, App, props, plugin }) {
    createApp({ render: () => h(App, props) })
      .use(plugin)
      .mount(el);

    router.on("navigate", (event) => {
      const pageTitle = event.detail.page.props.pageTitle;
      if (pageTitle) document.title = pageTitle;
    });
  },
});
